










































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { Patient } from "../../../../../domain/patient";
import { DuplicatedPatientSelectorMixin } from "../../mixins";

@Component({
})
export default class DuplicatedPatientSelector extends Mixins(DuplicatedPatientSelectorMixin) {
  async mounted(): Promise<void> {
    this.clearInformation();
    await this.updateDuplicatedPatients(this.sourceId);
  }

  private async updateDuplicatedPatients(sourceId: string): Promise<void> {
    if (!sourceId) { return; }
    this.isFinding = true;
    this.patients = await this.getDuplicatedPatients(sourceId);
    this.isFinding = false;
  }

  private async getDuplicatedPatients(sourceId: string): Promise<Patient[]> {
    try {
      const repository = DomainRegistry.patient.getPatientRepository();
      const result = await repository.getDuplicatedPatients(sourceId);
      return result;
    } catch (e) {
      this.$error("重複ID取得エラー", "患者重複ID取得に失敗しました。", e);
    }
  }

  @Watch("sourceId")
  async onSourceIdUpdated(newValue: string): Promise<void> {
    this.clearInformation();
    await this.updateDuplicatedPatients(newValue);
  }

}
